export default "__VITE_ASSET__CBC3Jz0U__"